﻿import StegValgModell from '../../Models/StegValgModell';

export interface ValgState {
    steg: StegValgModell[];
}

export const UPDATE_VALG = 'UPDATE_VALG';

interface UpdateValgAction {
    type: typeof UPDATE_VALG;
    payload: Partial<ValgState>;
}

export type ValgStateActionTypes = UpdateValgAction;
